import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IonModal, ModalController } from '@ionic/angular';
import { Experience } from 'src/app/models/ToursModels';
import { reviewExperience } from 'src/app/models/ToursModels/review';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { ExperienceService } from 'src/app/services/experience.service';
import { LoadingController } from '@ionic/angular';
import { ReviewService } from 'src/app/services/review.service';
import { AlertController, ToastController } from '@ionic/angular';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { ModalPicturePage } from 'src/app/components/modal-picture/modal-picture.page';
import { Share } from '@capacitor/share/dist/esm';

@Component({
  selector: 'app-experience-review',
  templateUrl: './experience-review.page.html',
  styleUrls: ['./experience-review.page.scss'],
})
export class ExperienceReviewPage implements OnInit {
  @ViewChild('nameInput', { static: false }) nameInput: any;
  @ViewChild('iptUploadImage', { static: false }) iptUploadImage: any;
  experienceDisplayed: Experience;
  form!: FormGroup;
  userName: string;
  isLoggedIn = false;
  user: User;
  photo: string;
  isLoading = false;
  isModalOpen = false;
  croppedImage: any = '';
  imageChangedEvent: any = '';
  isUploadImage = false;
  loading;
  isExperienceShare=false;
  experienceLink = '';


  @ViewChild(IonModal) modal: IonModal;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private experienceService: ExperienceService,
    public authService: AuthService,
    private loadingController: LoadingController,
    private reviewService: ReviewService,
    private toastController: ToastController,
    private alertController: AlertController,
    private modalCtrl: ModalController
  ) {
    this.randomPhoto();
    this.createform();
    this.getUserLogged();
    this.getExperience();
  }

  ngOnInit() {
  }

  async onShareLinkClipboard() {
    navigator.clipboard.writeText(this.experienceLink)
    .then(() => {
      this.createShareNotification();
    })
    .catch((error) => {
      console.error('Error al copiar al portapapeles: ', error);
    });
  }

  async onShareLink() {
    await Share.share({
      title: 'Compartir experiencia',
      text: this.experienceDisplayed?.title,
      url: this.experienceLink,
      dialogTitle: 'Miradores Medellín',
    });
  }

  async createShareNotification(): Promise<void> {

    const toast = await this.toastController.create({
      message: 'Enlace copiado al portapapeles',
      duration: 2000,
      position: 'top',
      color:'primary'
    });

    await toast.present();

  }

  focusInputName() {
    setTimeout(() => {
      this.nameInput.setFocus();
    }, 400);
  }

  editName() {
    this.form.get('userName').enable();
    this.focusInputName();
  }

  getUserLogged() {
    this.authService.$establishedSession.subscribe((user) => {
      if (user) {
        this.user = user;
        this.isLoggedIn = true;
        this.form.get('userName')?.setValue(this.user.displayName || 'Anónimo');
        this.photo = user.photoURL;
      } else {
        this.generateRandomUserName();
      }
    });
  }

  async getExperience() {
    const navigation = this.router.getCurrentNavigation();
    if (navigation && navigation.extras?.state) {
      this.experienceDisplayed = navigation.extras.state.experience;
      this.experienceLink = `https://med.miradores.co/experience/${this.experienceDisplayed._id}`;
    } else {
      this.presentLoading();
      this.experienceService.getExperiences();
      this.experienceService.$experiencesLoaded.subscribe((loaded) => {
        if (loaded) {
          this.route.paramMap.subscribe((params) => {
            this.experienceDisplayed = this.experienceService.getExperienceByID(
              params.get('experience')
            );
            this.experienceLink = `https://med.miradores.co/experience/${this.experienceDisplayed._id}`;
          });
        }
      });
    }
  }

  goBack() {
    this.router.navigate(['/experience', this.experienceDisplayed._id]);
  }

  createform() {
    this.form = this.fb.group({
      userName: [''],
      rating: [null, [Validators.required]],
      comment: [''],
      isAnonymous: [false],
    });
    this.form.get('userName').disable();
    this.form.get('isAnonymous').valueChanges.subscribe((data) => {
      if (data) {
        this.generateRandomUserName();
        this.randomPhoto();
      } else {
        this.getUserLogged();
      }
    });
  }

  setRating(star: number) {
    const currentRating = this.form.get('rating')?.value;
    this.form.get('rating')?.setValue(currentRating === star ? null : star);
  }

  randomPhoto() {
    var randomNumber = Math.floor(Math.random() * 10) + 1;
    var baseUrl =
      'https://firebasestorage.googleapis.com/v0/b/miradores-ac574.appspot.com/o/reviews-picture%2F';
    var token = '?alt=media&token=6a9c019d-c043-4d42-8221-2c3f7ef3604d';
    this.photo = baseUrl + randomNumber + '.png' + token;
  }

  generateRandomUserName() {
    const getRandomLetter = () =>
      String.fromCharCode(97 + Math.floor(Math.random() * 26));
    const randomNumber = Math.floor(Math.random() * 10000);
    const randomUsername = 'Anónimo ' + randomNumber + getRandomLetter();
    this.form.get('userName')?.patchValue(randomUsername);
  }

  onSaveReview() {
    this.presentLoading();
    if (this.form.get('userName').value === '') {
      this.form.get('userName').setValue('Anónimo');
    }
    let reviewExperience: reviewExperience = {
      ...this.form.getRawValue(),
      userId: this.user?.uid || null,
      date: Math.floor(new Date().getTime() / 1000),
      experienceId: this.experienceDisplayed._id,
      photoUrl: this.form.get('isAnonymous').value
        ? this.photo
        : this.user?.photoURL || this.photo,
      isAnonymous:
        this.form.get('isAnonymous').value || this.user?.uid === undefined,
    };

    if (this.isUploadImage) {
      const photoName = `experienceId${
        reviewExperience.experienceId
      }_Date${Date.now()}.png`;
      this.reviewService.uploadImageReview(this.croppedImage, photoName).then(
        (urlImage) => {
          reviewExperience.photoUrl = urlImage;
          this.addReview(reviewExperience);
        },
        (error) => {
          this.showErrorMessage();
        }
      );
    } else {
      this.addReview(reviewExperience);
    }
  }

  addReview(reviewExperience: reviewExperience) {
    this.reviewService
      .saveReviewExperience(reviewExperience)
      .then((result) => {
        this.showSuccessMessage();
        this.loading.dismiss();
        this.isExperienceShare = true;
      })
      .catch((err) => {
        console.log(err);
        this.showErrorMessage();
      });
  }

  async presentLoading() {
    this.loading = await this.loadingController.create({
      duration: 3200,
      translucent: true,
      backdropDismiss: false,
    });
    await this.loading.present();
  }

  async showSuccessMessage() {
    setTimeout(() => {
      this.randomPhoto();
      this.form.reset();
    }, 3000);
    const toast = await this.toastController.create({
      message: '¡Gracias por darle un toque mágico a nuestras experiencias!⭐',
      duration: 4000,
      position: 'top',
      color: 'success',
      buttons: [
        {
          side: 'end',
          icon: 'checkmark-circle',
        },
      ],
    });
    toast.present();
  }

  async showErrorMessage() {
    const alert = await this.alertController.create({
      header: 'Error al guardar la reseña',
      message:
        'Hubo un problema al guardar la reseña. Por favor, inténtalo de nuevo.',
      buttons: ['OK'],
    });
    alert.present();
  }

  fileChangeEvent(event: any) {
    this.imageChangedEvent = event;
    const file = event.target.files[0];
    const img = new Image();

    img.onload = async () => {
      if (img.width < 480) {
        const toast = await this.toastController.create({
          message: 'Selecciona una imagen de minimo 1080px de ancho',
          position: 'top',
          color: 'tertiary',
          buttons: [
            {
              icon: 'close-circle-outline',
              role: 'cancel',
            },
          ],
          duration: 4500,
        });
        await toast.present();
      } else {
        this.isModalOpen = true;
      }
    };

    img.src = URL.createObjectURL(file);
  }

  onWillDismiss(event: Event) {
    this.isModalOpen = false;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  cropperReady() {}

  loadImageFailed() {
    console.error('Load failed');
  }

  saveCropped() {
    this.resetInputFile();
    if (this.croppedImage !== undefined) {
      this.photo = this.croppedImage;
      this.isUploadImage = true;
      this.isModalOpen = false;
    }
  }

  resetInputFile() {
    this.iptUploadImage.nativeElement.value = '';
  }

  async openModalPicture(photo: string) {
    const modal = await this.modalCtrl.create({
      component: ModalPicturePage,
      componentProps: {
        photo,
      },
      cssClass: 'transparent-modal',
    });
    return await modal.present();
  }
}
